export const ContractAmendmentStatus = {
  QUOTED: 1,
  APPROVED: 2,
  DECLINED: 3,
};